"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactToastify = require("react-toastify");

var _styled = require("./styled");

var _helpers = require("./helpers");

var _hooks = require("../../hooks");

var _reactProvider = require("@trycourier/react-provider");

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Body = function Body(_ref) {
  var _ref3, _props$brand, _brand$inapp, _ref4, _brand$inapp2, _brand$inapp2$icons, _blocksByType$text, _blocksByType$text2;

  var title = _ref.title,
      body = _ref.body,
      blocks = _ref.blocks,
      icon = _ref.icon,
      data = _ref.data,
      onClick = _ref.onClick,
      messageId = _ref.messageId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title", "body", "blocks", "icon", "data", "onClick", "messageId"]);
  var _ref2 = props,
      toastProps = _ref2.toastProps;

  var _useToast = (0, _hooks.useToast)(),
      _useToast2 = (0, _slicedToArray2["default"])(_useToast, 2),
      config = _useToast2[1].config;

  var _useCourier = (0, _reactProvider.useCourier)(),
      courierBrand = _useCourier.brand,
      dispatch = _useCourier.dispatch;

  var brand = (_ref3 = (_props$brand = props.brand) !== null && _props$brand !== void 0 ? _props$brand : config === null || config === void 0 ? void 0 : config.brand) !== null && _ref3 !== void 0 ? _ref3 : courierBrand;
  var renderBlocks = config.renderBlocks,
      openLinksInNewTab = config.openLinksInNewTab;
  var handleOnClickDismiss = (0, _react.useCallback)(function () {
    return _reactToastify.toast.dismiss(toastProps === null || toastProps === void 0 ? void 0 : toastProps.toastId);
  }, [toastProps === null || toastProps === void 0 ? void 0 : toastProps.toastId]);
  var Icon = (0, _helpers.getIcon)(
  /* priority:
    1. from message
    2. from props.defaultIcon
    3. from props.brand.inapp.icons.message
    4. from remote brand.inapp.icons.message
  */
  brand !== null && brand !== void 0 && (_brand$inapp = brand.inapp) !== null && _brand$inapp !== void 0 && _brand$inapp.disableMessageIcon ? false : (_ref4 = icon || (config === null || config === void 0 ? void 0 : config.defaultIcon)) !== null && _ref4 !== void 0 ? _ref4 : brand === null || brand === void 0 ? void 0 : (_brand$inapp2 = brand.inapp) === null || _brand$inapp2 === void 0 ? void 0 : (_brand$inapp2$icons = _brand$inapp2.icons) === null || _brand$inapp2$icons === void 0 ? void 0 : _brand$inapp2$icons.message);

  var handleClickMessage = function handleClickMessage(event) {
    var _data$trackingIds, _data$trackingIds2;

    event === null || event === void 0 ? void 0 : event.preventDefault();

    if (data !== null && data !== void 0 && (_data$trackingIds = data.trackingIds) !== null && _data$trackingIds !== void 0 && _data$trackingIds.clickTrackingId && data !== null && data !== void 0 && (_data$trackingIds2 = data.trackingIds) !== null && _data$trackingIds2 !== void 0 && _data$trackingIds2.readTrackingId) {
      dispatch({
        type: "inbox/MARK_MESSAGE_READ",
        payload: {
          messageId: messageId
        }
      });
    }

    if (onClick) {
      onClick(event);
    }
  };

  var blocksByType = (0, _react.useMemo)(function () {
    return blocks === null || blocks === void 0 ? void 0 : blocks.reduce(function (acc, cur) {
      if (cur.type === "text") {
        acc.text.push(cur);
      }

      if (cur.type === "action") {
        acc.action.push(cur);
      }

      return acc;
    }, {
      action: [],
      text: []
    });
  }, [blocks]);
  var clickAction = (0, _react.useMemo)(function () {
    var _blocksByType$action;

    if (data !== null && data !== void 0 && data.clickAction) {
      return data.clickAction;
    }

    if (!(blocksByType !== null && blocksByType !== void 0 && blocksByType.action.length) || ((_blocksByType$action = blocksByType.action) === null || _blocksByType$action === void 0 ? void 0 : _blocksByType$action.length) > 1) {
      return;
    }

    return blocksByType.action[0].url;
  }, []);
  var containerProps = {};

  if (clickAction) {
    containerProps.href = clickAction;
    containerProps.onMouseDown = handleClickMessage;

    if (openLinksInNewTab) {
      containerProps = _objectSpread(_objectSpread({}, containerProps), {}, {
        target: "_blank",
        rel: "noreferrer"
      });
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_styled.Container, null, /*#__PURE__*/_react["default"].createElement("a", containerProps, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    "data-testid": "message-icon"
  }), /*#__PURE__*/_react["default"].createElement(_styled.Message, {
    "data-testid": "message"
  }, title && /*#__PURE__*/_react["default"].createElement(_styled.Title, {
    "data-testid": "message-title"
  }, title), blocksByType !== null && blocksByType !== void 0 && (_blocksByType$text = blocksByType.text) !== null && _blocksByType$text !== void 0 && _blocksByType$text.length ? blocksByType === null || blocksByType === void 0 ? void 0 : (_blocksByType$text2 = blocksByType.text) === null || _blocksByType$text2 === void 0 ? void 0 : _blocksByType$text2.map(function (block, index) {
    if (block.type === "text") {
      if (renderBlocks !== null && renderBlocks !== void 0 && renderBlocks.text) {
        var Block = renderBlocks === null || renderBlocks === void 0 ? void 0 : renderBlocks.text;
        return /*#__PURE__*/_react["default"].createElement(Block, (0, _extends2["default"])({}, block, {
          key: index
        }));
      }

      return /*#__PURE__*/_react["default"].createElement(_styled.TextBlock, {
        key: index,
        "data-testid": "message-body"
      }, block.text && /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, block.text));
    }
  }) : /*#__PURE__*/_react["default"].createElement(_styled.TextBlock, {
    "data-testid": "message-body"
  }, typeof body === "string" ? /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, body) : body))), /*#__PURE__*/_react["default"].createElement(_styled.Dismiss, {
    "data-testid": "dismiss",
    onClick: handleOnClickDismiss
  }, "X"));
};

var _default = Body;
exports["default"] = _default;